import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "campervanFilled"
const CampervanFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.75 16.125C7.786 16.125 8.625 16.965 8.625 18S7.785 19.875 6.75 19.875 4.875 19.035 4.875 18 5.715 16.125 6.75 16.125M18.375 16.125C19.41 16.125 20.25 16.965 20.25 18S19.41 19.875 18.375 19.875 16.5 19.035 16.5 18 17.34 16.125 18.375 16.125M10.5 8.625C10.707 8.625 10.875 8.793 10.875 9V11.25C10.875 11.457 10.707 11.625 10.5 11.625H5.25C5.043 11.625 4.875 11.457 4.875 11.25V9C4.875 8.793 5.043 8.625 5.25 8.625z" />
          <path
            fillRule="evenodd"
            d="M18.713 3.563C19.163 3.563 19.58 3.792 19.821 4.17L20.627 5.438H19.31V6.563H21.343L21.49 6.795 21.54 6.878C22.007 7.74 21.387 8.812 20.384 8.813H18.33L18.333 8.815H16.96L16.958 8.813H15.375C15.271 8.813 15.188 8.896 15.188 9V17.813H9.367C9.276 16.524 8.257 15.493 6.973 15.385Q6.931 15.381 6.888 15.38 6.82 15.375 6.75 15.375T6.61 15.379Q6.568 15.38 6.528 15.385C5.244 15.492 4.224 16.523 4.133 17.813H3.375C2.235 17.813 1.313 16.889 1.313 15.75V14.813H1.875C2.185 14.813 2.438 14.56 2.438 14.25S2.186 13.688 1.875 13.688H1.313V5.624C1.313 4.485 2.236 3.563 3.375 3.563zM5.25 7.875C4.629 7.875 4.125 8.379 4.125 9V11.25C4.125 11.871 4.629 12.375 5.25 12.375H10.5C11.121 12.375 11.625 11.871 11.625 11.25V9C11.625 8.379 11.121 7.875 10.5 7.875z"
            clipRule="evenodd"
          />
          <path d="M20.228 11.524 21.79 12.045C22.326 12.225 22.688 12.725 22.688 13.29V13.689H22.125C21.815 13.688 21.563 13.939 21.563 14.25 21.563 14.56 21.814 14.813 22.125 14.813H22.688V16.5C22.688 17.225 22.1 17.813 21.375 17.813H20.992C20.9 16.524 19.882 15.493 18.598 15.385Q18.556 15.381 18.513 15.38 18.445 15.375 18.375 15.375T18.235 15.379Q18.193 15.38 18.153 15.385C17.142 15.47 16.296 16.128 15.938 17.034V11.438H18.795L17.485 9.565H18.856z" />
        </svg>
      }
    </span>
  )
}
export default CampervanFilledIcon
